module.exports = __webpack_public_path__ + "static/media/Hannah Stuhr Headshot.58701fce.jpeg";